export default {"src":"/_next/static/media/search.93799d3a.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};